export const getPaymentCardsLoaded = (state: WtrState) =>
  state?.payment?.paymentCardsLoaded ?? false;
